import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '@/providers/auth-provider'
import { fetchAccountProfile } from '@/lib/api'

/** Current member Workspace Desk slug from GET /api/account/profile. */
export function useAccountDeskSlug() {
  const { session, isAuthConfigured } = useAuth()
  const userId = session?.user?.id
  const [deskSlug, setDeskSlug] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    if (!isAuthConfigured || !userId) {
      setDeskSlug(null)
      setLoading(false)
      return
    }
    setLoading(true)
    try {
      const data = await fetchAccountProfile()
      const slug = typeof data.deskSlug === 'string' ? data.deskSlug.trim() : ''
      setDeskSlug(slug || null)
    } catch {
      setDeskSlug(null)
    } finally {
      setLoading(false)
    }
  }, [isAuthConfigured, userId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { deskSlug, loading, refresh }
}
